export default __webpack_public_path__ + "static/media/datsun.5b457e08.webp";